// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"711":"5101917e","713":"ff197d8f","787":"781721cd"}[chunkId] + ".chunk.js";
};